( function ( $ ) {
	const isDesktop = () => window.matchMedia( '(min-width: 992px)' ).matches;

	// Toggle dropdown on click of the parent link; prevent navigation
	$( document ).on( 'click', '.menu-item-has-children > .nav-link', function ( e ) {
		e.preventDefault();
		e.stopPropagation();
		const $parent = $( this ).parent();
		const wasOpen = $parent.hasClass( 'show' );
		$( '.menu-item' ).removeClass( 'show' );
		if ( ! wasOpen ) {
			$parent.addClass( 'show' );
		}
	} );

	// Hover-open on desktop
	$( '.navigation .menu-item-has-children' ).on( 'mouseenter', function () {
		if ( ! isDesktop() ) return;
		$( '.menu-item' ).removeClass( 'show' );
		$( this ).addClass( 'show' );
	} ).on( 'mouseleave', function () {
		if ( ! isDesktop() ) return;
		$( this ).removeClass( 'show' );
	} );

	// Close when clicking outside
	$( document ).on( 'click', function ( e ) {
		if ( ! $( e.target ).closest( '.menu-item-has-children' ).length ) {
			$( '.menu-item' ).removeClass( 'show' );
		}
	} );

	// Close on Escape
	$( document ).on( 'keydown', function ( e ) {
		if ( e.key === 'Escape' ) {
			$( '.menu-item' ).removeClass( 'show' );
		}
	} );

	$( '.menu-toggle' ).click( function () {
		$( '.mobile-navigation' ).toggleClass( 'is-open' );
	} );
	$( '.mobile-navigation-close' ).click( function () {
		$( '.mobile-navigation' ).removeClass( 'is-open' );
	} );

	// FAQ accordion
	$( document ).on( 'click', '.faq-item__question', function () {
		$( this ).closest( '.faq-item' ).toggleClass( 'is-open' );
	} );

	// ---- Variation colour swatches ----
	// Swatches sit in front of the (visually hidden) <select> WC renders.
	// Clicking a swatch sets the select value + dispatches 'change' so all
	// of WC's variation JS (price/image/availability) continues to work.
	$( document ).on( 'click', '.swatch-group .swatch', function ( e ) {
		e.preventDefault();
		const $swatch = $( this );
		const $row    = $swatch.closest( 'tr' );
		const $select = $row.find( 'select' );
		if ( ! $select.length ) return;

		const value = $swatch.data( 'value' );
		$select.val( value ).trigger( 'change' );
	} );

	// Keep swatches in sync when WC clears or changes the select externally
	// (e.g. "Clear" link, or other attribute selection invalidating this one).
	$( document ).on( 'change', '.variations select', function () {
		const $select = $( this );
		const $row    = $select.closest( 'tr' );
		const $group  = $row.find( '.swatch-group' );
		if ( ! $group.length ) return;

		const val = $select.val();
		$group.find( '.swatch' ).each( function () {
			const isMatch = String( $( this ).data( 'value' ) ) === String( val );
			$( this ).toggleClass( 'is-active', isMatch );
		} );
	} );

	// ---- Product gallery thumbnails ----
	// Click a thumbnail → swap [data-product-gallery-main] src.
	$( document ).on( 'click', '.product-gallery__thumb', function ( e ) {
		e.preventDefault();
		const $thumb = $( this );
		const $gallery = $thumb.closest( '[data-product-gallery]' );
		const $main = $gallery.find( '[data-product-gallery-main]' );
		const fullSrc = $thumb.data( 'fullSrc' );
		if ( ! $main.length || ! fullSrc ) return;

		$main.attr( 'src', fullSrc ).removeAttr( 'srcset' );
		$gallery.find( '.product-gallery__thumb' ).removeClass( 'is-active' );
		$thumb.addClass( 'is-active' );
	} );

	// ---- Product image lightbox ----
	// Click the main image → open the gallery in Fancybox at the currently
	// shown image. The hidden .product-gallery__lightbox anchors are the
	// Fancybox group (bound globally in main.js); we just trigger the right one.
	$( document ).on( 'click', '[data-product-gallery-main]', function () {
		const $gallery = $( this ).closest( '[data-product-gallery]' );
		const $anchors = $gallery.find( '.product-gallery__lightbox a' );
		if ( ! $anchors.length ) return;
		let idx = $gallery.find( '.product-gallery__thumb.is-active' ).index();
		if ( idx < 0 ) idx = 0;
		const target = $anchors.get( Math.min( idx, $anchors.length - 1 ) );
		if ( target ) target.click();
	} );

	// ---- Product image mouse zoom ----
	// On desktop, hovering the main image scales it up and pans toward the
	// cursor. The `overflow: hidden` frame clips the scaled image, so this is a
	// contained "inner zoom" — no extra lens or overlay needed. Disabled on
	// touch / small screens where hover has no meaning.
	const ZOOM = 2;
	$( document ).on( 'mouseenter', '.product-gallery__main', function () {
		if ( ! isDesktop() ) return;
		$( this ).find( '[data-product-gallery-main]' ).addClass( 'is-zooming' );
	} );
	$( document ).on( 'mousemove', '.product-gallery__main', function ( e ) {
		if ( ! isDesktop() ) return;
		const $img = $( this ).find( '[data-product-gallery-main]' );
		if ( ! $img.length ) return;
		const rect = this.getBoundingClientRect();
		const x = ( ( e.clientX - rect.left ) / rect.width ) * 100;
		const y = ( ( e.clientY - rect.top ) / rect.height ) * 100;
		$img.css( {
			'transform-origin': x + '% ' + y + '%',
			transform: 'scale(' + ZOOM + ')',
		} );
	} );
	$( document ).on( 'mouseleave', '.product-gallery__main', function () {
		$( this ).find( '[data-product-gallery-main]' )
			.removeClass( 'is-zooming' )
			.css( { transform: '', 'transform-origin': '' } );
	} );

	// ---- Variation image swap (partial-match) ----
	// WC's `found_variation` event only fires when ALL attributes are selected.
	// For products with multiple attributes (e.g. Farbe + Grösse) the user expects
	// the image to swap as soon as they pick a colour, even if size is still empty.
	// We hook the raw select change instead and resolve the best-matching variation
	// from $form.data('product_variations') ourselves. A variation attribute of ""
	// is treated as "any", matching WC's own match_attributes logic.
	$( document ).on( 'change', '.variations select', function () {
		const $form    = $( this ).closest( '.variations_form' );
		const $product = $form.closest( '.product' );
		const $main    = $product.find( '[data-product-gallery-main]' );
		if ( ! $main.length ) return;

		// The first hidden lightbox anchor corresponds to the featured image, i.e.
		// the same slot the main image starts on. When a variation swaps the main
		// image we repoint this anchor to the variation's full-size image so the
		// lightbox opens the variation, not the original featured image.
		const $firstAnchor = $product.find( '.product-gallery__lightbox a' ).first();

		if ( ! $main.data( 'origSrc' ) ) {
			$main.data( 'origSrc', $main.attr( 'src' ) || '' );
			$main.data( 'origSrcset', $main.attr( 'srcset' ) || '' );
			$main.data( 'origAlt', $main.attr( 'alt' ) || '' );
		}
		if ( $firstAnchor.length && $firstAnchor.data( 'origHref' ) === undefined ) {
			$firstAnchor.data( 'origHref', $firstAnchor.attr( 'href' ) || '' );
		}

		const variations = $form.data( 'product_variations' );
		if ( ! variations ) return;

		// Collect only the attributes the user has actually picked.
		const selected = {};
		let hasAny = false;
		$form.find( '.variations select' ).each( function () {
			const name = $( this ).attr( 'name' );
			const val  = $( this ).val();
			if ( name && val ) {
				selected[ name ] = val;
				hasAny = true;
			}
		} );

		// Nothing selected → restore featured image + first thumb active.
		if ( ! hasAny ) {
			$main.attr( 'src', $main.data( 'origSrc' ) );
			if ( $main.data( 'origSrcset' ) ) {
				$main.attr( 'srcset', $main.data( 'origSrcset' ) );
			} else {
				$main.removeAttr( 'srcset' );
			}
			if ( $main.data( 'origAlt' ) ) {
				$main.attr( 'alt', $main.data( 'origAlt' ) );
			}
			$product.find( '.product-gallery__thumb' ).removeClass( 'is-active' )
				.first().addClass( 'is-active' );
			if ( $firstAnchor.length && $firstAnchor.data( 'origHref' ) ) {
				$firstAnchor.attr( 'href', $firstAnchor.data( 'origHref' ) );
			}
			return;
		}

		// Find first variation whose attributes are compatible with the user's pick.
		const match = variations.find( function ( v ) {
			return Object.keys( selected ).every( function ( key ) {
				const attr = v.attributes[ key ];
				return attr === '' || attr === selected[ key ];
			} );
		} );

		if ( ! match || ! match.image || ! match.image.src ) return;

		$main.attr( 'src', match.image.src );
		if ( match.image.srcset ) {
			$main.attr( 'srcset', match.image.srcset );
		} else {
			$main.removeAttr( 'srcset' );
		}
		if ( match.image.alt ) {
			$main.attr( 'alt', match.image.alt );
		}

		// Point the lightbox at the variation's full-size image so a click on the
		// swapped main image opens the matching variation, not the featured image.
		if ( $firstAnchor.length ) {
			$firstAnchor.attr( 'href', match.image.full_src || match.image.src );
		}

		$product.find( '.product-gallery__thumb' ).removeClass( 'is-active' );
	} );

	// ---- Search overlay ----
	const $overlay = $( '[data-search-overlay]' );
	const $input   = $( '[data-search-input]' );

	function openSearch () {
		$overlay.attr( 'hidden', false ).attr( 'aria-hidden', 'false' ).addClass( 'is-open' );
		$( 'body' ).addClass( 'has-search-open' );
		setTimeout( function () { $input.trigger( 'focus' ); }, 50 );
	}
	function closeSearch () {
		$overlay.removeClass( 'is-open' ).attr( 'aria-hidden', 'true' ).attr( 'hidden', true );
		$( 'body' ).removeClass( 'has-search-open' );
	}

	$( document ).on( 'click', '[data-search-toggle]', function ( e ) {
		e.preventDefault();
		openSearch();
	} );
	$( document ).on( 'click', '[data-search-close]', closeSearch );
	$overlay.on( 'click', function ( e ) {
		if ( e.target === this ) closeSearch();
	} );
	$( document ).on( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && $overlay.hasClass( 'is-open' ) ) closeSearch();
	} );
} )( jQuery );
